import React from 'react';

const IconCashbackRedeemed = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16082_60673)'>
      <path
        d='M0.381676 14.0363C0.080687 14.1472 -0.074456 14.4808 0.0351886 14.7829L0.401527 15.7909L3.19087 13.0015L0.381676 14.0363Z'
        fill='#FCA600'
      />
      <path
        d='M3.02148 22.996L4.70143 27.6158C4.75392 27.7617 4.86357 27.8807 5.00356 27.9448C5.08171 27.981 5.16571 27.9997 5.2497 27.9997C5.31855 27.9997 5.3862 27.988 5.45155 27.9635L7.30533 27.2799L3.02148 22.996Z'
        fill='#FCA600'
      />
      <path
        d='M27.964 19.0516L26.0414 13.7657L21.4274 18.3797L23.714 17.5374C24.0138 17.423 24.3521 17.5793 24.4629 17.8827C24.5749 18.1848 24.4198 18.5208 24.1176 18.6317L21.2127 19.7026C21.1462 19.7271 21.0785 19.7388 21.0108 19.7388C20.774 19.7388 20.55 19.5929 20.4637 19.3573C20.4626 19.3538 20.4637 19.3503 20.4626 19.3468L15.5732 24.2361L27.6175 19.7983C27.9196 19.6875 28.0747 19.3538 27.964 19.0516Z'
        fill='#FCA600'
      />
      <path
        d='M27.8288 9.50398L18.4958 0.170955C18.2683 -0.0565373 17.8985 -0.0565373 17.671 0.170955L0.171596 17.6703C-0.0558964 17.8978 -0.0558964 18.2677 0.171596 18.4952L9.50462 27.8282C9.61776 27.9425 9.76711 27.9997 9.91646 27.9997C10.0658 27.9997 10.2151 27.9425 10.3294 27.8293L27.8288 10.3299C28.0563 10.1013 28.0563 9.73262 27.8288 9.50398ZM6.82956 16.1631L4.4963 18.4963C4.38195 18.6095 4.23266 18.6667 4.08331 18.6667C3.93396 18.6667 3.78467 18.6095 3.67032 18.4963C3.44283 18.2688 3.44283 17.899 3.67032 17.6715L6.00359 15.3382C6.23109 15.1107 6.60092 15.1107 6.82842 15.3382C7.05591 15.5658 7.05706 15.9344 6.82956 16.1631ZM16.9034 16.9039C16.4904 17.3169 15.9292 17.5152 15.3051 17.5152C14.2737 17.5152 13.0686 16.9751 12.0607 15.9659C11.3234 15.2286 10.8054 14.3466 10.6036 13.4833C10.3796 12.5209 10.5639 11.6833 11.1227 11.1233C11.6815 10.5633 12.5192 10.3789 13.4828 10.6041C14.3461 10.806 15.2281 11.3228 15.9653 12.0612C17.5858 13.6805 17.9988 15.8084 16.9034 16.9039ZM24.3289 10.3299L21.9957 12.6632C21.8813 12.7764 21.732 12.8336 21.5827 12.8336C21.4333 12.8336 21.2841 12.7764 21.1697 12.6632C20.9422 12.4357 20.9422 12.0659 21.1697 11.8384L23.503 9.50513C23.7305 9.27763 24.1003 9.27763 24.3278 9.50513C24.5553 9.73262 24.5564 10.1013 24.3289 10.3299Z'
        fill='#17C981'
      />
    </g>
    <defs>
      <clipPath id='clip0_16082_60673'>
        <rect width='28' height='28' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default IconCashbackRedeemed;
